const DefaultOverline = 'Overline Text';
const DefaultHeadlineShort = 'Here\u2019s a short headline.';
const DefaultHeadlineShort2 = 'Another short headline.';
const DefaultHeadlineLong =
  'Here\u2019s a longer headline that helps you see what this area looks like with\u00a0some longer text.';
const DefaultBodyShort = 'This short paragraph is here to help visualize this unique section.';
const DefaultBodyStandard =
  'A lot of times it\u2019s hard to see what a section might look like on your website. This paragraph is to help give you a feeling for it. Replace this text with your own.';
const DefaultBodyLong =
  'A lot of times it\u2019s hard to see what a section might look like on your website. This longer paragraph is here to help. Replace this text with your own. The rest of this longer paragraph is also filler text. So don\u2019t use this on your real website or people might be confused. It\u2019s always best to write your own.';
const DefaultBodyLong2 =
  'That being said, sometimes it\u2019s necessary to use filler words to say something that you don\u2019t quite have the words for yet. That makes it more helpful to make decisions on content length.';
const DefaultBodyLong3 =
  'So, you\u2019re welcome for this, but we should stop now. You can take it from here and make your bold move!';

export const defaultText = {
  overline: {
    standard: DefaultOverline,
  },
  headline: {
    short: DefaultHeadlineShort,
    short2: DefaultHeadlineShort2,
    long: DefaultHeadlineLong,
  },
  body: {
    short: DefaultBodyShort,
    standard: DefaultBodyStandard,
    long: DefaultBodyLong,
    long2: DefaultBodyLong2,
    long3: DefaultBodyLong3,
  },
};
